export const trimSpaces = (text: string) => {
  if (text.match(/^\s/)) {
    text = text.replace(/^\s/, '');
  }
  if (text.match(/\s$/)) {
    text = text.replace(/\s$/, '');
  }
  return text;
}
